import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../features/auth/AuthContext";
import { TimeRange } from "../../utils/timerange";
import { fetchDistinctProtocols } from "../queries/artifacts";

interface UseDistinctProtocolsParams {
  timeRange: TimeRange;
  permittedEmails: string[] | null;
}

export const useDistinctProtocols = (params: UseDistinctProtocolsParams) => {
  const { tenantId } = useAuth();
  const { timeRange, permittedEmails } = params;

  return useQuery({
    queryKey: ["distinctProtocols", tenantId, timeRange, permittedEmails],
    queryFn: () => fetchDistinctProtocols({ timeRange, permittedEmails }),
    staleTime: 1 * 60 * 1000, // 5 minutes - protocols don't change often
    gcTime: 2 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};
